import { render, staticRenderFns } from "./ResumeEducationItem.vue?vue&type=template&id=19169d96&"
import script from "./ResumeEducationItem.vue?vue&type=script&lang=js&"
export * from "./ResumeEducationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports